import React from 'react';
import { mediaUrl, srcSet } from './media';

interface PictureProps {
  /** Base name in public/media, without width or extension. */
  name: string;
  widths: readonly number[];
  alt: string;
  /** Intrinsic size of the largest file, so the browser reserves the box (CLS). */
  width: number;
  height: number;
  sizes?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
}

/** AVIF → WebP → JPEG `<picture>` over one width ladder. */
const Picture: React.FC<PictureProps> = ({
  name,
  widths,
  alt,
  width,
  height,
  sizes = '100vw',
  className,
  loading = 'lazy',
  fetchPriority,
}) => {
  const largest = widths[widths.length - 1];
  return (
    <picture className={className}>
      <source type="image/avif" srcSet={srcSet(name, widths, 'avif')} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet(name, widths, 'webp')} sizes={sizes} />
      <img
        src={mediaUrl(`${name}-${largest}.jpg`)}
        srcSet={srcSet(name, widths, 'jpg')}
        sizes={sizes}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
      />
    </picture>
  );
};

export default Picture;
